/**
 * @ngdoc service
 * @name billing.invoices.factory:Invoices
 *
 * @description
 *
 */

angular
    .module('festzelt-os.billing.invoices')
    .factory('Invoice', [
        'locale',
        'Resource',
        'FileSaver',
        'Alert',
        'Env',
        '$http',
        'ResourceCommon',
        Invoice
    ]);

function Invoice(locale, Resource, FileSaver, Alert, Env, $http, ResourceCommon) {
    const $model = Resource.make('billing/invoices');
    $model.title = 'Invoice ';

    locale.ready(['billing']).then(function () {
        $model.schema = {
            type: 'object',
            title: locale.getString('billing.invoices.title'),
            properties: {
                id: {
                    title: locale.getString('billing.invoices.fields.id'),
                    type: 'number',
                    listview: 'hidden'
                },
                invoice_number: {
                    title: locale.getString('billing.invoices.fields.invoice_number'),
                    type: 'string',
                    columnDef: {
                        main: true
                    }
                },
                number_circle_id: {
                    title: locale.getString('billing.invoices.fields.number_circle_id'),
                    type: 'number',
                    listview: 'hidden'
                },
                type: {
                    title: locale.getString('billing.invoices.fields.type'),
                    type: 'integer',
                    columnDef: {}
                },
                status: {
                    title: locale.getString('billing.invoices.fields.status'),
                    type: 'integer',
                    columnDef: {}
                },
                tax_rate: {
                    title: locale.getString('billing.invoices.fields.tax_rate'),
                    type: 'number',
                    columnDef: {}
                },
                subject: {
                    title: locale.getString('billing.invoices.fields.subject'),
                    type: 'string',
                    columnDef: {}
                },
                performance_period: {
                    title: locale.getString('billing.invoices.fields.performance_period'),
                    type: 'string',
                    columnDef: {}
                },
                text1: {
                    title: locale.getString('billing.invoices.fields.text1'),
                    type: 'string',
                    columnDef: {}
                },
                text2: {
                    title: locale.getString('billing.invoices.fields.text2'),
                    type: 'string',
                    columnDef: {}
                },
                text3: {
                    title: locale.getString('billing.invoices.fields.text3'),
                    type: 'string',
                    columnDef: {}
                }
            }
        };
    });


    $model.form = [
        'title',
        'label',
        'description',
        'unit',
        'price_per_unit'
    ];

    $model.downloadInvoice = function (id, name) {
        if (!name) {
            name = 'invoice-' + id + '.pdf';
        }
        $http.get(Env.apiUrl + '/billing/invoices/' + id + '/download', {responseType: "blob"})
            .then(function (response) {
                const blob = new Blob([response.data], {type: response.headers('content-type')});
                FileSaver.saveAs(blob, name);
            }, function (response) {

                // @todo new alert - reponse empty (undefined)
                Alert.handle(response);
            });
    };

    $model.finishInvoice = function (invoice) {
        return $http.get(Env.apiUrl + '/billing/invoices/' + invoice.id + '/finish')
            .then(function (response) {
                Alert.success('Success', 'Invoice finished');
            }, function (response) {

                // @todo new alert - reponse empty (undefined)
                Alert.handle(response);
            });
    };

    $model.cancelInvoice = function (invoice, data) {
        return $http.post(Env.apiUrl + '/billing/invoices/' + invoice.id + '/cancel', data);
    };

    $model.sendInvoice = function (invoice, contact) {
        return ResourceCommon.selectEmailTemplate(true, contact).then((data) => {
            return $model.sendInvoiceWithTemplate(invoice, contact, data.template.id, data.attach_invoice, data.send_to_override);
        }, () => {

        });
    };

    $model.sendInvoiceWithTemplate = function (invoice, contact, templateId, attachInvoice, sendToOverride) {
        return $http.post(Env.apiUrl + '/billing/invoices/' + invoice.id + '/send', {
            send_to_email: sendToOverride ? sendToOverride : contact.preferred_email,
            template_id: templateId,
            contact_id: contact.id,
            attach_invoice: attachInvoice
        });
    };

    return $model;
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/factories/invoice-factory.js